export default __webpack_public_path__ + "static/media/Caldo-Verde.8003f8cd.jpg";